import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppData } from '@shared/models/appdata.model';
import { MobilePhoneFilters } from '../models/mobilephone-filters';
import { HardwareVariant, HardwareVariantGroup } from '../models/mobilephone-variant';
import { MobilePhoneBundleOffering } from '../models/mobilephone-bundleoffering';

@Injectable({
  providedIn: 'root',
})
export class MobilephoneSearchService {
  private http = inject(HttpClient);
  private appData = inject(AppData);

  getMobilePhoneVariantGroups(): Observable<HardwareVariantGroup[]> {
    let url = `${this.appData.apiUrl}/api/v1/product/mobilephones`;

    return this.http.get<HardwareVariant[]>(url);
  }

  getMobilePhoneVariants(groupSlug: string): Observable<HardwareVariant[]> {
    let url = `${this.appData.apiUrl}/api/v1/product/mobilephones/group/${groupSlug}`;

    return this.http.get<HardwareVariant[]>(url);
  }

  getMobilePhoneByBundleOfferingId(offeringId: string): Observable<MobilePhoneBundleOffering> {
    const url = `${this.appData.apiUrl}/api/v1/product/bundleOffering/${offeringId}/mobilephone`;
    return this.http.get<MobilePhoneBundleOffering>(url);
  }

  getMobilephoneFilters(): Observable<MobilePhoneFilters> {
    const url = `${this.appData.apiUrl}/api/v1/product/mobilephones/filters`;
    return this.http.get<MobilePhoneFilters>(url);
  }
}
